var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntervencionesOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83242 5.19372L3.41119 3.77917L4.11242 3.07794L5.52698 4.49917L4.83242 5.19372ZM11.3333 0.5V2.5H10.3333V0.5H11.3333ZM17.5541 3.07794L18.2553 3.77917L16.8341 5.19372L16.1395 4.49917L17.5541 3.07794ZM2.83325 10V11H0.833252V10H2.83325ZM18.8333 10H20.8333V11H18.8333V10ZM16.8333 19.5C17.2311 19.5 17.6126 19.658 17.8939 19.9393C18.0536 20.099 18.1736 20.291 18.2475 20.5H3.41904C3.49292 20.291 3.61289 20.099 3.77259 19.9393C4.0539 19.658 4.43543 19.5 4.83325 19.5H16.8333ZM10.8333 4.5C12.2919 4.5 13.6909 5.07946 14.7223 6.11091C15.7538 7.14236 16.3333 8.54131 16.3333 10V17.5H5.33325V10C5.33325 8.54131 5.91271 7.14236 6.94416 6.11091C7.97562 5.07946 9.37456 4.5 10.8333 4.5Z",
    fill: "#DBE5E8",
    stroke: "#163C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntervencionesOutlined);
export default __webpack_public_path__ + "static/media/IntervencionesOutlined.25372c09c0f9b709570da0309babca2b.svg";
export { ForwardRef as ReactComponent };